import { Checkbox, FormHelperText, Grid, TextField, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { SignupFormData } from "../../models/signup-model";
import { UtilityService } from "../../services/UtilityService";
import UnAuthComponent from "../layout/unauth.component";
import ButtonComponent from "../shared/button/button.component";
import { appNote, buttonLabels, SignupTitles, TextFieldLabels, ToasterTexts, ViewTextLabels } from "../shared/constants";
import { validateForm } from "../shared/form-validation";
import { Helmet } from "react-helmet";
import { EmailService } from "../../services/email.service";
import Config from "../../config";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { SucessComponent } from "./sucess";
import { AppRoutes } from "../routes/route.path";
import { Link } from "react-router-dom";
import { ArrowForwordIcon, FalconLogo, FbIcon, InstaIcon, LinkdinIcon, LoginScreenMobileBG, SignUpIcon, WebIcon, YoutubeIcon } from "../../icon";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import Carousel from "../login/Carousel";
import LoginScreenRight1 from '../../icons/loginScreenRight1.svg';
import LoginScreenRight2 from '../../icons/loginScreenRight2.svg';

interface Props { }

const SignUpComponent = (props: Props) => {

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)

    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [isMailSent, setIsMailSent] = useState<boolean>(false);
    const [isAgree, setIsAgree] = useState<boolean>(false);
    const [signUpFormData, setsignUpFormData] = useState<SignupFormData>({
        FirstName: "",
        LastName: "",
        Email: "",
        MobileNumber: "",
        Organization: ""
    });

    const [errors, setErrors] = useState({ FirstName: "", LastName: "", Email: "", MobileNumber: "", Organization: "" });
    const [isTouched, setIsTouched] = useState({ FirstName: false, LastName: false, Email: false, MobileNumber: false, Organization: false });
    const [isFormValid, setIsFormValid] = useState<boolean>(false);

    const formSubmit = (e: any) => {
        e.preventDefault();
        setIsTouched({ ...isTouched, FirstName: true, LastName: true, Email: true, MobileNumber: true, Organization: true })
        if (ValidateForm()) {
            var UserData = {
                FirstName: signUpFormData.FirstName,
                LastName: signUpFormData.LastName,
                Email: signUpFormData.Email,
                MobileNumber: UtilityService.unmaskPhoneNumber(signUpFormData.MobileNumber),
                Organization: signUpFormData.Organization,
            }
            setShowLoader(true);
            let setEmail = Config.IS_PROD_ENV ? Config.SALES_EMAIL : Config.ISSUE_REPORT_EMAIL;
            EmailService.userRegistrationDetailsToSupport([{ Email: setEmail, Name: "" }], UserData).then(res => {
                setShowLoader(false)
                setIsMailSent(true)
            }
            ).catch((error: any) => {
                if (!!error) {
                    setShowLoader(false);
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                    setIsTouched({ ...isTouched, FirstName: false, LastName: false, Email: false, MobileNumber: false, Organization: false })
                }
            })
        }
    }

    const ValidateForm = () => validateForm({
        FirstName: signUpFormData.FirstName,
        LastName: signUpFormData.LastName,
        Email: signUpFormData.Email,
        MobileNumber: signUpFormData.MobileNumber,
        Organization: signUpFormData.Organization
    }, (Errors) => {
        setErrors({ ...errors, ...Errors });
    })

    const HandleCheckBox = (e: any) => {
        setIsAgree(e.target.checked)
    }

    const onBlur = (e: any) => {
        setIsTouched({
            ...isTouched, [e.target.name]: true
        })
    }

    const onChange = (e: any) => {
        setsignUpFormData({ ...signUpFormData, [e.target.name]: e.target.value })
        setIsTouched({
            ...isTouched, [e.target.name]: true
        })
    }

    useEffect(() => {
        const validResult = ValidateForm();
        setIsFormValid(validResult)
    }, [signUpFormData])

    return (
        <>
            <h1 className="hide-element">Falkon SMS</h1>
            <Helmet>
                <meta name="description" content="Sign-up with FalkonSMS to start texting and connecting with your customers via your Toll-Free, Landline, VoIP and MS Teams direct routing numbers." />
            </Helmet>
            {!isMailSent ?
                <div className={`m-auto ${IsTeamsApp ? "h-v-100 o-y-scroll" : "h-v-100"}`}>
                    {IsMobileDevice && <div className="p-absolute t-0 r-0" style={{ zIndex: -1 }}>
                        <LoginScreenMobileBG />
                    </div>
                    }
                    {IsMobileDevice &&
                        <div className='w-p-100 h-p-10 d-flex align-end pl-6'>
                            <FalconLogo className={"w-20"} />
                        </div>
                    }
                    <div className={`d-flex  ${IsMobileDevice ? "h-p-90" : "h-p-100"} w-p-100`}>
                        {!IsMobileDevice && <div className={`d-flex align-center flex-direction h-p-100 w-p-45 signup-left-bg`}>
                            <Carousel ParentComponent={ViewTextLabels.SIGN_UP} />
                        </div>
                        }
                        <div className={` ${IsMobileDevice ? "w-p-100" : "w-p-55  justify-center"} h-p-100 d-flex flex-direction p-relative`}>
                            {!IsMobileDevice &&
                                <div className="p-absolute t-0 l-0 w-30" style={{ zIndex: -1 }}>
                                    <img src={LoginScreenRight1} alt="" className="w-p-100" />
                                </div>
                            }
                            {!IsMobileDevice &&
                                <div className="p-absolute b-0 r-0 w-60" style={{ zIndex: -1 }}>
                                    <img src={LoginScreenRight2} alt="" className="w-p-100" />
                                </div>
                            }
                            <div className={`${IsMobileDevice ? "h-p-90" : "h-p-85"} d-flex justify-center flex-direction align-center w-p-100 `} >
                                <form className={`${IsMobileDevice ? "w-p-70" : "w-p-50 min-w-50 mt-auto pb-4"} d-flex flex-direction justify-center align-center`} onSubmit={formSubmit}>
                                    <div className={`w-p-100 d-flex justify-center min-h-10 h-p-10 ${IsMobileDevice && "align-center"}`}>
                                        <span className={"h1-semibold color-login-headers w-space"}>
                                            Sign up to Falkon SMS
                                        </span>
                                    </div>
                                    <div className={`w-p-100 ${IsMobileDevice ? "" : "d-flex justify-between"}`}>
                                        <div className={`${IsMobileDevice ? "w-p-100" : "w-p-48"}`}>
                                            <TextField
                                                label="First Name*"
                                                error={isTouched.FirstName && !!errors.FirstName}
                                                name="FirstName"
                                                placeholder="First Name"
                                                variant="standard"
                                                size="small"
                                                fullWidth
                                                value={signUpFormData.FirstName}
                                                onBlur={onBlur}
                                                onChange={(e) => { onChange(e) }}
                                                InputProps={{ classes: { input: `h4-regular` } }}
                                                autoComplete='no'
                                                autoFocus
                                                className={`unauth-border ${isTouched.FirstName && errors.FirstName ? "unauth-border-error" : ""} w-p-100 min-h-6 h-p-6`}
                                            />
                                            <FormHelperText className={`w-p-100 h5-regular color-primary-danger t-align-left min-h-3 h-p-3`}>
                                                {isTouched.FirstName && errors.FirstName}
                                            </FormHelperText>
                                        </div>
                                        <div className={`${IsMobileDevice ? "w-p-100" : "w-p-48"}`}>
                                            <TextField
                                                label="Last Name*"
                                                error={isTouched.LastName && !!errors.LastName}
                                                placeholder="Last Name"
                                                name="LastName"
                                                variant="standard"
                                                size="small"
                                                fullWidth
                                                value={signUpFormData.LastName}
                                                onBlur={onBlur}
                                                onChange={(e) => { onChange(e) }}
                                                InputProps={{ classes: { input: `h4-regular` } }}
                                                autoComplete='no'
                                                className={`unauth-border ${isTouched.LastName && errors.LastName ? "unauth-border-error" : ""} w-p-100 min-h-6 h-p-6`}
                                            />
                                            <FormHelperText className={`w-p-100 h5-regular color-primary-danger t-align-left min-h-3 h-p-3`}>
                                                {isTouched.LastName && errors.LastName}
                                            </FormHelperText>
                                        </div>
                                    </div>
                                    <TextField
                                        label="Email*"
                                        error={isTouched.Email && !!errors.Email}
                                        fullWidth
                                        name="Email"
                                        placeholder="Email"
                                        size="small"
                                        variant="standard"
                                        value={signUpFormData.Email}
                                        onBlur={onBlur}
                                        onChange={(e) => { onChange(e) }}
                                        InputProps={{ classes: { input: `h4-regular` } }}
                                        autoComplete='no'
                                        className={`unauth-border ${isTouched.Email && errors.Email ? "unauth-border-error" : ""} w-p-100 min-h-6 h-p-6`}
                                    />
                                    <FormHelperText className={`w-p-100 h5-regular color-primary-danger t-align-left min-h-3 h-p-3`}>
                                        {isTouched.Email && errors.Email}
                                    </FormHelperText>
                                    <TextField
                                        label="Mobile number*"
                                        error={isTouched.MobileNumber && !!errors.MobileNumber}
                                        name="MobileNumber"
                                        placeholder="Mobile Number"
                                        variant="standard"
                                        size="small"
                                        fullWidth
                                        onBlur={onBlur}
                                        value={UtilityService.maskPhoneNumber(signUpFormData.MobileNumber)}
                                        onChange={(e) => { onChange(e) }}
                                        InputProps={{ classes: { input: `h4-regular` } }}
                                        autoComplete='no'
                                        className={`unauth-border ${isTouched.MobileNumber && errors.MobileNumber ? "unauth-border-error" : ""} w-p-100 min-h-6 h-p-6`}
                                    />
                                    <FormHelperText className={`w-p-100 h5-regular color-primary-danger t-align-left min-h-3 h-p-3`}>
                                        {isTouched.MobileNumber && errors.MobileNumber}
                                    </FormHelperText>
                                    <TextField
                                        label="Organization*"
                                        error={isTouched.Organization && !!errors.Organization}
                                        fullWidth
                                        name="Organization"
                                        placeholder="Organization"
                                        size="small"
                                        variant="standard"
                                        value={signUpFormData.Organization}
                                        onBlur={onBlur}
                                        onChange={(e) => { onChange(e) }}
                                        InputProps={{ classes: { input: `h4-regular` } }}
                                        autoComplete='no'
                                        className={`unauth-border ${isTouched.Organization && errors.Organization ? "unauth-border-error" : ""} w-p-100 min-h-6 h-p-6`}
                                    />
                                    <FormHelperText className={`w-p-100 h5-regular color-primary-danger t-align-left min-h-3 h-p-3`}>
                                        {isTouched.Organization && errors.Organization}
                                    </FormHelperText>
                                    <div className="w-p-100 d-flex align-center min-h-4 h-p-3 mb-2 pr-2">
                                        <Checkbox checked={isAgree}
                                            value={isAgree} className={""} style={isAgree ? {} : { color: "red" }} onChange={HandleCheckBox} classes={{ checked: "selected-checkbox" }} />
                                        <span className={`h5-regular color-sign-up-Iaccept-label my-auto`}>I accept the&nbsp;
                                            <a href='https:www.falkonsms.com/terms-of-service'
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={`color-primary-light h5-regular c-pointer`}>
                                                {buttonLabels.TERMS_OF_SERVICE}
                                            </a>
                                            &nbsp;and&nbsp;
                                            <a href='https:www.falkonsms.com/privacy-policy'
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={`color-primary-light c-pointer h5-regular`}>
                                                {buttonLabels.PRIVACY_POLICY}
                                            </a>
                                        </span>
                                    </div>
                                    <button
                                        data-arrow-index={9}
                                        data-up-arrow-index={8}
                                        data-down-arrow-index={9}
                                        data-left-arrow-index={2}
                                        data-right-arrow-index={9}
                                        tabIndex={4} type="submit"
                                        className={`c-pointer justify-center d-flex w-space h4-regular w-fill br-2 t-align-center primary-btn w-p-100 align-center unauth-screen-button-gredient m-0 h-p-4 min-h-5 ${!isFormValid || !isAgree ? "disabled-btn" : "primary-btn"}`}>
                                        {showLoader && <span className="mr-1 loader-primary my-auto"></span>}
                                        <span className={"my-auto mr-1"}>{buttonLabels.SIGN_UP}</span>
                                        <ArrowForwordIcon />
                                    </button>
                                    <div className={"w-p-100 t-align-center h5-regular color-primary-accent mt-2"} style={{ zIndex: 1 }}>
                                        <span >
                                            {appNote.ALREADY_HAVE_AN_ACCOUNT}&nbsp;
                                        </span>
                                        <span>
                                            <Link tabIndex={5}
                                                data-arrow-index={10}
                                                data-up-arrow-index={6}
                                                data-down-arrow-index={7}
                                                data-left-arrow-index={2}
                                                data-right-arrow-index={10}
                                                to={AppRoutes.SIGN_IN} className={"color-login-link c-pointer text-style w-space m-auto"}> {ViewTextLabels.SIGN_IN}</Link>                                        </span>
                                    </div>
                                </form>
                            </div>
                            {!IsMobileDevice &&
                                !IsTeamsApp &&
                                <div className="h-p-15 d-flex justify-center min-h-12 min-w-50 w-p-50 mx-auto">
                                    <div className="w-p-100 d-flex flex-direction align-center h-p-100">
                                        <div className="w-p-100 h-p-20 h6-medium mb-0 d-flex justify-between">
                                            <div className="">
                                                <a href='https://www.falkonsms.com/terms-of-service'
                                                    target="_blank"
                                                    data-arrow-index={3}
                                                    data-up-arrow-index={1}
                                                    data-down-arrow-index={1}
                                                    data-left-arrow-index={5}
                                                    data-right-arrow-index={4}
                                                    className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                                    {buttonLabels.TERMS_OF_SERVICE}
                                                </a>
                                            </div>
                                            <div className="">
                                                <a href='https://www.falkonsms.com/privacy-policy'
                                                    target="_blank"
                                                    data-arrow-index={4}
                                                    data-up-arrow-index={2}
                                                    data-down-arrow-index={2}
                                                    data-left-arrow-index={3}
                                                    data-right-arrow-index={5}
                                                    className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                                    {buttonLabels.PRIVACY_POLICY}
                                                </a>
                                            </div>
                                            <div className="">
                                                <a href='https://www.falkonsms.com/cookie-policy'
                                                    target="_blank"
                                                    data-arrow-index={5}
                                                    data-up-arrow-index={2}
                                                    data-down-arrow-index={3}
                                                    data-left-arrow-index={4}
                                                    data-right-arrow-index={9}
                                                    className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                                    {"Cookie Policy"}
                                                </a>
                                            </div>
                                            <div className="">
                                                <a href='https://www.falkonsms.com/acceptable-use-policy'
                                                    target="_blank"
                                                    data-arrow-index={5}
                                                    data-up-arrow-index={2}
                                                    data-down-arrow-index={4}
                                                    data-left-arrow-index={4}
                                                    data-right-arrow-index={9}
                                                    className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                                    {"Acceptable Use Policy"}
                                                </a>
                                            </div>
                                        </div>
                                        <div className="h-p-20 w-p-60">
                                            <div className="d-flex justify-between align-center mt-2">
                                                <div className="">
                                                    <a href='https://www.falkonsms.com/'
                                                        data-arrow-index={1}
                                                        data-up-arrow-index={1}
                                                        data-down-arrow-index={0}
                                                        data-left-arrow-index={1}
                                                        data-right-arrow-index={2}
                                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                                        <Tooltip title='Website' placement='bottom-end' classes={{ popper: "tooltip-z-index" }}>
                                                            <WebIcon />
                                                        </Tooltip>
                                                    </a>
                                                </div>
                                                <div className="">
                                                    <a href='https://www.facebook.com/falkonsystems2021'
                                                        data-arrow-index={2}
                                                        data-up-arrow-index={2}
                                                        data-down-arrow-index={0}
                                                        data-left-arrow-index={1}
                                                        data-right-arrow-index={3}
                                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                                        <Tooltip title='Facebook' placement='bottom' classes={{ popper: "tooltip-z-index" }}>
                                                            <FbIcon />
                                                        </Tooltip>
                                                    </a>
                                                </div>
                                                <div className="">
                                                    <a href='https://www.linkedin.com/company/falkon-systems/'
                                                        data-arrow-index={3}
                                                        data-up-arrow-index={3}
                                                        data-down-arrow-index={0}
                                                        data-left-arrow-index={2}
                                                        data-right-arrow-index={4}
                                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                                        <Tooltip title='LinkedIn' placement='bottom' classes={{ popper: "tooltip-z-index" }}>
                                                            <LinkdinIcon />
                                                        </Tooltip>
                                                    </a>
                                                </div>
                                                <div className="">
                                                    <a href='https://www.instagram.com/falkon_systems_/'
                                                        data-arrow-index={4}
                                                        data-up-arrow-index={2}
                                                        data-down-arrow-index={0}
                                                        data-left-arrow-index={3}
                                                        data-right-arrow-index={5}
                                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                                        <Tooltip title='Instagram' placement='bottom' classes={{ popper: "tooltip-z-index" }}>
                                                            <InstaIcon />
                                                        </Tooltip>
                                                    </a>
                                                </div>
                                                <div className="">
                                                    <a href='https://www.youtube.com/channel/UCP_hOtnoImVPCleutK9mLtA'
                                                        data-arrow-index={5}
                                                        data-up-arrow-index={2}
                                                        data-down-arrow-index={0}
                                                        data-left-arrow-index={4}
                                                        data-right-arrow-index={6}
                                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                                        <Tooltip title='Youtube' placement='bottom-start' classes={{ popper: "tooltip-z-index" }}>
                                                            <YoutubeIcon />
                                                        </Tooltip>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div >
                </div >
                : <SucessComponent FirstName={signUpFormData.FirstName} />}
        </>
    )
}
export default SignUpComponent;